import { getRedirectCompetition } from "utils/competition"
import { ParsedUrlQuery } from "querystring"
import { GetStaticPropsContext } from "next"
import { CompetitionAPI } from "../../../src/apis/CompetitionAPI"
import {
  default as CompetitionPage,
  getStaticProps as getStaticPropsCompetitionPage,
  IParams as IParamsCompetitionPage,
} from "./stagione/[seasonCalciocomSlug]/gruppo/[groupCalciocomSlug]/giornata/[turnCalciocomSlug]/calendario-risultati"

export default CompetitionPage

export async function getStaticPaths() {
  return { paths: [], fallback: "blocking" }
}

interface IParams extends ParsedUrlQuery {
  competitionCalciocomSlug: string
}

export async function getStaticProps(context: GetStaticPropsContext<IParams>) {
  try {
    const { competitionCalciocomSlug } = context.params!

    const competition = await CompetitionAPI.getCompetitionByCalciocomSlug(competitionCalciocomSlug)
    const { competitionSlug, seasonSlug, groupSlug, turnSlug } = await getRedirectCompetition(competition)
    const destinationContext: GetStaticPropsContext<IParamsCompetitionPage> = {
      params: {
        competitionCalciocomSlug: competitionSlug!,
        seasonCalciocomSlug: seasonSlug!,
        groupCalciocomSlug: groupSlug!,
        turnCalciocomSlug: turnSlug!,
      },
    }

    return getStaticPropsCompetitionPage(destinationContext, true)
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
